import { useState } from "react";

export function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      case "ExistingEmployee":
        setFilterDataIndex(2);
        break;
      case "NonExistingEmployee":
        setFilterDataIndex(3);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
        <option value="ExistingEmployee">Existing Employee</option>
        <option value="NonExistingEmployee">Non Existing Employee</option>
      </select>
    </div>
  );
};